<template>
  <div>
    <Breadcrumbs main="Widgets" title="Role Model" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-xl-12">
          <div class="card">
            <div class="card-body default-according">
              <div class="row mb-4">
                  <div class="col-6">
                      <div class="col-form-label">Departement</div>
                      <multiselect
                        v-model="departemen_model"
                        :options="departemen"
                        label="name"
                        :searchable="false"
                        :show-labels="false"
                        placeholder="(Pilih Departemen)"
                        @select="fetchDataById"
                      ></multiselect>
                    </div>

                </div>
              <b-card no-body class="mb-1" v-for="(item,idx) in data" :key="idx">

                <b-card-header header-tag="div" class="bg-primary">
                  <h5 class="mb-0">
                    <b-button v-b-toggle :href="`#parimary-${idx}`" @click.prevent>{{ item.name }}</b-button
                    >
                  </h5>
                </b-card-header>
                <b-collapse
                  :id="`parimary-${idx}`"
                  visible
                  accordion="my-accordion-icon-open-close"
                  role="tabpanel"
                >
                  <b-card-body>
                    <h6 class="mb-3">Variabel Internal</h6>
                    <div class="table-responsive datatable-vue m-0 vue-smart">
                      <v-table
                          :data="item.detail_variabel" class="table"
                          :pageSize="100"
                      >
                        <thead slot="head">
                        <v-th sortKey="name">Name</v-th>
                        <v-th sortKey="position">Role Model Value</v-th>
                        <v-th sortKey="office">Indicator Actived</v-th>
                        <v-th sortKey="age">Corelation</v-th>
                        <v-th sortKey="startdate">Source</v-th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                          <template v-for="row in displayData">
                            <tr v-if="row.source == 0" :key="`test-${row.id}`" >
                              <td>{{ covertName(row.column_database) }}</td>
                              <td>{{ row.role_model }}</td>
                              <td><h5><span class="badge " :class="[row.indicator == 1 ? 'badge-success' : 'badge-danger']">{{ row.indicator == 1 ? 'Yes' : 'No' }}</span></h5></td>
                              <td><h5><span class="badge " :class="[row.corelation == 1 ? 'badge-success' : 'badge-danger']">{{ row.corelation == 1 ? 'Positive' : 'Negatif' }}</span></h5></td>
                              <td>{{ row.source == '0' ? 'Internal' : 'External' }}</td>
                            </tr>
                          </template>

                        </tbody>
                      </v-table>
                    </div>

                    <h6 class="mt-4 mb-3">Variabel External</h6>
                    <div class="table-responsive datatable-vue m-0 vue-smart">
                      <v-table
                          :data="item.detail_variabel" class="table"
                          :pageSize="100"
                      >
                        <thead slot="head">
                        <v-th sortKey="name">Name</v-th>
                        <v-th sortKey="position">Role Model Value</v-th>
                        <v-th sortKey="office">Indicator Actived</v-th>
                        <v-th sortKey="age">Corelation</v-th>
                        <v-th sortKey="startdate">Source</v-th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                          <template v-for="row in displayData">
                            <tr v-if="row.source == 1" :key="`test-${row.id}`" >
                              <td>{{ covertName(row.column_database) }}</td>
                              <td>{{ row.role_model }}</td>
                              <td><h5><span class="badge " :class="[row.indicator == 1 ? 'badge-success' : 'badge-danger']">{{ row.indicator == 1 ? 'Yes' : 'No' }}</span></h5></td>
                              <td><h5><span class="badge " :class="[row.corelation == 1 ? 'badge-success' : 'badge-danger']">{{ row.corelation == 1 ? 'Positive' : 'Negatif' }}</span></h5></td>
                              <td>{{ row.source == '0' ? 'Internal' : 'External' }}</td>
                            </tr>
                          </template>

                        </tbody>
                      </v-table>
                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import {  getDataRoleModelByIdDepartemen } from "../../_services/role_model.service";
import Multiselect from "vue-multiselect";
import { getDataDepartemen } from "../../_services/data.service";

export default {
  name: "GeneralWidgets",
  data() {
    return {
      data: [],
      departemen : [],
      departemen_model: ''
    };
  },
  components: {
      Multiselect,
    },
  watch: {},
  async mounted() {
    this.departemen = await getDataDepartemen();
  },
  methods: {
    async fetchDataById(departemen){
      this.data = await getDataRoleModelByIdDepartemen(departemen.id);
    },
    async fetchData() {
      let role = await this.$store.dispatch("match_scoring/getDataRoleModel");
      this.roleModelOption = role.data;
      this.role = role.data[0];

      this.dataChart();
      this.dataCandidate();
    },
    covertName(name){
      let data = name.split("_");
      var name_convert = '';
      data.forEach(element => {
        name_convert += String(element).toUpperCase();
        name_convert += ' ';
      });
      return name_convert;

    }
  },
};
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
